import { useNotifsStore } from "../../../../stores/Utils/notifs";
import {
  dateFormat,
  hourFormat,
  splitMissionName,
} from "../../../../services/Utils/functionService";
import { NavLink } from "react-router-dom";
import { usePartnerRequestsStore2 } from "../../../../stores/Cac/Partner/partnerRequests";
import cloche from "../../../../assets/icons/bellBlack.svg";
import message from "../../../../assets/icons/message-square.svg";
import doc from "../../../../assets/icons/file-text.svg";

const Notifs = () => {
  const { showNotifs, notifs } = useNotifsStore();
  const { setOpenDetails, setRequestId } = usePartnerRequestsStore2();

  return (
    <div id="modal-Notifs">
      {showNotifs && (
        <div
          className="fixed bottom-16 left-2 right-2 z-40 h-[min(500px,calc(100dvh-5rem))] rounded-xl bg-white p-3 shadow-2xl sm:absolute sm:bottom-auto sm:left-14 sm:right-auto sm:top-44 sm:mt-2 sm:h-[500px] sm:w-[350px] sm:p-4 lg:w-[500px]"
        >
          <div className="flex justify-start items-center w-full border border-gray-200 rounded-xl shadow-md p-2">
            <div className="p-2 bg-yellow-trio rounded-xl flex justify-center items-center">
              <img src={cloche} alt="document" className="w-5 h-5" />
            </div>
            <p className="text-start font-BarlowCondensed text-lg w-full sticky top-0 z-10 p-2 ml-2">
              Notifications
            </p>
          </div>
          
          {notifs.length === 0 && (
            <p className=" text-center font-BarlowCondensed italic text-grey-trio mt-4">
              Vous n'avez pas reçu de notifications
            </p>
          )}
          <div
            className={` bg-white h-[70%] mt-2 ${
              notifs.length > 3 ? "overflow-y-scroll" : ""
            }`}
          >
            {notifs?.map((notif) => (
              <button
                key={notif.id}
                className="border border-gray-100 mb-2 pb-2 flex flex-col justify-start items-start w-full hover:bg-light-lavender hover:bg-opacity-20 rounded-xl"
                onClick={() => {
                  setRequestId(notif?.idDocRequest);
                  setOpenDetails(true);
                }}
              >
                <NavLink
                  key={notif.id}
                  to={
                    notif.isCustomer ? `/customer/${notif.idCustomer}/missions/${notif.idMission}/requests`
                      : `/partner/${notif.idPartner}/customers/${notif.idCustomer}/missions/${notif.idMission}/requests`
                  }
                >
                  <div className="flex justify-start items-center w-full">
                    <div className="p-2 bg-light-lavender rounded-xl flex justify-center items-center mt-2 ml-1 mr-2">
                      {notif?.idCategoryNotification === 2 ? (
                        <img src={doc} alt="document" className="" />
                      ) : (
                        <img src={message} alt="message" className="" />
                      )}
                    </div>
                    <div className="flex flex-col justify-start items-center w-full">
                      <div className="w-full flex justify-start items-center">
                        <p className="text-xs text-gray-700 font-bold text-start py-1 mr-2">
                          {splitMissionName(notif?.missionName)}
                        </p>
                        <p className="text-xs text-gray-500 text-start py-1">
                          {dateFormat(notif?.createdAt) +
                            " " +
                            hourFormat(notif?.createdAt)}
                        </p>
                      </div>
                      <p className="text-xs text-start">{notif?.text}</p>
                    </div>
                  </div>
                </NavLink>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Notifs;
